import React, { createContext, useContext, useEffect, useState } from "react";
import Papa from "papaparse";
import { RawRow } from "../types";

export type { RawRow };

interface DataContextValue {
  rows: RawRow[];
  loading: boolean;
  error: string | null;
}

const DataContext = createContext<DataContextValue>({
  rows: [],
  loading: true,
  error: null,
});

export const DataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [rows, setRows] = useState<RawRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Papa.parse("/data/results.csv", {
      header: true,
      download: true,
      dynamicTyping: false,
      skipEmptyLines: true,
      complete: (res) => {
        const valid = (res.data as RawRow[]).filter(
          (r) => r.date && r.home_team && r.away_team
        );
        setRows(valid);
        setLoading(false);
      },
      error: (err) => {
        setError(err.message || "Failed to load data");
        setLoading(false);
      },
    });
  }, []);

  return (
    <DataContext.Provider value={{ rows, loading, error }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
